export class EventSessionFeedComponent {
  container;

  constructor() {
    this.container = document.querySelector('.event-session-feed');
  }

  initialize() {
    if (!this.container) {
      return;
    }

    this.addEventListeners();
  }

  addEventListeners() {
    if (!this.container.classList.contains('has-several-items')) {
      return;
    }

    const openItems = [...this.container.querySelectorAll('.js-open')];
    openItems.forEach((openItem) => {
      openItem.addEventListener('click', (e) => this.openItemClickHandler(e));
    });

    const closeControls = [...this.container.querySelectorAll('.js-close')];
    closeControls.forEach((closeControl) => {
      closeControl.addEventListener('click', (e) => this.closeControlClickHandler(e));
    });

    const toggleControls = [...this.container.querySelectorAll('.js-toggle')];
    toggleControls.forEach((toggleControl) => {
      toggleControl.addEventListener('click', (e) => this.toggleControlClickHandler(e));
    });
  }

  openItemClickHandler(e) {
    const target = e.target.closest('.js-open');
    if (!target) {
      return;
    }

    const container = target.closest('.event-session-feed__item');
    if (!container || container.classList.contains('active')) {
      return;
    }

    container.classList.add('active');
  }

  closeControlClickHandler(e) {
    const container = e.target.closest('.event-session-feed__item');
    if (!container || !container.classList.contains('active')) {
      return;
    }

    container.classList.remove('active');
  }

  toggleControlClickHandler(e) {
    const container = e.target.closest('.event-session-feed__item');
    if (!container) {
      return;
    }

    container.classList.contains('active') ? container.classList.remove('active') : container.classList.add('active');
  }
} 